module.exports = __webpack_public_path__ + "img/help_mech.09504048.svg";